import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import './CrossPlatformSection.css';

const CrossPlatformSection = () => {
  return (
    <Box className="cross-platform-section">
      <Container maxWidth="lg">
        <motion.div 
          className="platform-content"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Typography 
            variant="h2" 
            className="platform-title"
            component={motion.h2}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Cross-Platform Excellence
          </Typography>
          <Typography 
            className="platform-description"
            component={motion.p}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            In today's interconnected world, success demands versatility. At Virves, we specialize in developing solutions that transcend platform limitations. Our expertise spans across multiple technologies and frameworks, ensuring your software performs flawlessly wherever your business takes you.
          </Typography>
        </motion.div>
      </Container>
    </Box>
  );
};

export default CrossPlatformSection; 